import { useFormContext, useFormState } from 'react-hook-form'

import * as S from './text-input.styled'

export type TextInputProps = {
  label: string
  name: string
  placeholder: string
  extraInfo?: string
  maxLength?: number
}

const TextInputInfo = ({ error, extraInfo }: { extraInfo?: string; error?: string }) => {
  if (error) {
    return <S.ErrorMessage>{error}</S.ErrorMessage>
  }
  if (extraInfo) {
    return <S.ExtraInfo>{extraInfo}</S.ExtraInfo>
  }
  return null
}

export const TextInput = ({ extraInfo, label, maxLength, name, placeholder }: TextInputProps) => {
  const { register, getFieldState } = useFormContext()
  const formState = useFormState({ name })
  const { error } = getFieldState(name, formState)

  return (
    <S.Container>
      <S.Label htmlFor={name}>{label}</S.Label>
      <S.Input
        $hasError={!!error}
        maxLength={maxLength}
        placeholder={placeholder}
        type="text"
        {...register(name)}
      />
      <TextInputInfo error={error?.message} extraInfo={extraInfo} />
    </S.Container>
  )
}
